import { httpClient } from '@/modules/common/services/http/http-client';
import { HomeBalanceHero } from './types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_CONSOLIDATION_URL}/consolidation`
});

export function getHeroBalanceAndButtons(): Promise<HomeBalanceHero> {
  return http.get('/v1/balance/hero');
}
